<template>
  <div class="notfound">
    <div class="notfound-desc">
      <img src="../../assets/smile.png" alt=""  class="notfound-img">
    </div>
    <p class="notfound-desc">暂无此账户信息，不能使用！</p>
    <!-- <div class="notfound-desc">
      <button class="notfound-btn" @click="goBack">返回上一级</button>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>
<style lang="less" scoped>
.notfound {
  &-desc {
    text-align: center;
    font-size: @m-font-size;
    padding-top: 30px;
    color: @content-font-color;
  }
  &-img {
    width: 60px;
    margin-top: 100px;
  }
  &-btn {
    padding: 12px 24px;
    background:#ffffff;
    border:1px solid rgba(44, 102, 248, 1);
    border-radius:4px;
    color: #2C66F8
  }
}
</style>
